/**
 * ViewModeToggle — Toggle between categorized, alphabetical, and grid views.
 */

import { Layers as LayersIcon,LayoutGrid, List } from 'lucide-react';
import React from 'react';

import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { type ToolBrowserViewMode,useToolBrowserStore } from '@/store/useToolBrowserStore';

const VIEW_MODES: { key: ToolBrowserViewMode; label: string; Icon: typeof List }[] = [
  { key: 'categorized', label: 'Categorized', Icon: LayersIcon },
  { key: 'flat', label: 'Alphabetical', Icon: List },
  { key: 'grid', label: 'Grid', Icon: LayoutGrid },
];

export const ViewModeToggle: React.FC = () => {
  const viewMode = useToolBrowserStore((s) => s.viewMode);
  const setViewMode = useToolBrowserStore((s) => s.setViewMode);

  return (
    <TooltipProvider>
      <div className="flex items-center gap-0.5 rounded-md border border-border p-0.5">
        {VIEW_MODES.map(({ key, label, Icon }) => (
          <Tooltip key={key}>
            <TooltipTrigger asChild>
              <button
                className={cn(
                  'rounded p-1 transition-colors',
                  viewMode === key
                    ? 'bg-accent text-accent-foreground'
                    : 'text-muted-foreground hover:bg-accent/60',
                )}
                onClick={() => setViewMode(key)}
                aria-label={label}
              >
                <Icon className="h-3.5 w-3.5" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="bottom">{label}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
};
